import PropTypes from 'prop-types';
import React from 'react';

import { ProjectCategoryLinks } from '$partials/global/index.js';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @param {PropTypes.InferProps<typeof propTypes>} props
 */
const TextColumnModule = ({
    heading,
    textBlocks
}) => {
    return (
        <div
            className='pt-40 pb-60 sm:pt-60 sm:pb-80 mb-[1px] rounded mr-1 col-span-3 sm:col-span-5 md:col-span-7 lg:col-span-9 bg-foreground'>
            <div className='flex flex-col sm:flex-row'>
                {/* Col 1 */}
                <div className='px-layout-item sm:pr-0 sm:w-1/5 md:w-2/7 lg:w-3/9 mb-40 sm:mb-60'>
                    <h3 className='type-style-2'>{heading}</h3>
                </div>

                {/* Col 2 */}
                {textBlocks?.length > 0 && (
                    <div className='px-layout-item sm:pl-80 sm:pr-layout-item lg:px-layout-item grid sm:grid-cols-2 sm:w-4/5 gap-40 md:gap-60 lg:w-5/9'>
                        {textBlocks.map((block, i) => {
                            if (!block) { return null; }
                            return (
                                <div
                                    className='max-w-[30em] lg:max-w-[38em]'
                                    key={`textBlock-${i}`}>
                                    <div className='w-full'>
                                        {block.heading &&
                                            <h3 className='type-style-4 sm:type-style-2'>{block.heading}</h3>
                                        }

                                        {block.body &&
                                            <div
                                                className='type-style-4 mt-15 rich-text'
                                                dangerouslySetInnerHTML={{ __html: block.body }} />
                                        }

                                        {block.projectCategories?.length > 0 &&
                                            <div className='width-full flex flex-wrap gap-10 mt-20'>
                                                <ProjectCategoryLinks categories={block.projectCategories} />
                                            </div>
                                        }
                                    </div>
                                </div>

                            );
                        })}
                    </div>
                )}

                {/* Spacer Col */}
                <div className='lg:px-layout-item w-0 lg:w-1/9' />
            </div>
        </div>
    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

const propTypes = {
    heading: PropTypes.string,
    textBlocks: PropTypes.array
};

TextColumnModule.propTypes = propTypes;

export default TextColumnModule;
